export default __webpack_public_path__ + "static/media/detritus1-new-crop.0e70de8d.jpg";